























import { defineComponent, computed } from "@vue/composition-api";
import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { getAppointmentType } from "@/lib/appointmentHelpers";
import BaseIcon from "@/components/Base/BaseIcon";
import { AppointmentsTabNameEnum } from "@/views/PageAppointments/config";
import NotificationItemView from "../../NotificationItemView.vue";

export default defineComponent({
  name: "NotificationAppointmentApproved",
  components: { BaseIcon, NotificationItemView },
  props: {
    notification: { type: Object as () => Notification, required: true },
  },
  setup(props) {
    const { isCreator } = useAuthUser();
    const appointmentType = getAppointmentType(props.notification.details.appointment);
    const link = computed(() => ({
      name: "appointments",
      query: {
        tab: isCreator.value ? AppointmentsTabNameEnum.UPCOMING_WITH_ME : AppointmentsTabNameEnum.MY_UPCOMING,
      },
    }));
    return {
      appointmentType,
      link,
    };
  },
});
